import { render, staticRenderFns } from "./TablaPlaDedicacio.vue?vue&type=template&id=1377cc4c&scoped=true&"
import script from "./TablaPlaDedicacio.vue?vue&type=script&lang=js&"
export * from "./TablaPlaDedicacio.vue?vue&type=script&lang=js&"
import style0 from "./TablaPlaDedicacio.vue?vue&type=style&index=0&id=1377cc4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1377cc4c",
  null
  
)

export default component.exports